// Instance
import MainAPI from "@/app/apis/main/main-api.js"

// Endpoints
import { API, ENDPOINTS } from "@/app/apis/main/_connection/connection-api.js"

// Query String
const queryString = require("querystring")

class BreedAPI extends MainAPI {
	/**
	 * @return {object} breeds list
	 */
	async getBreeds() {
		return API.get(ENDPOINTS.GET_BREEDS)
	}

	/**
	 * @return {object} breeds info; general, health, exercise
	 */
	async getBreedInfo(breedId) {
		return API.get(`${ENDPOINTS.GET_BREEDS}/${breedId}/info`)
	}

	/**
	 * @return {object} breed info for health alerts notification
	 */
	async getBreedInfoByID(infoId) {
		return API.get(`${ENDPOINTS.GET_BREED_INFO}/${infoId}`)
	}

	/**
	 * @return {object} breeder list
	 */
	async getBreeders(queryParams) {
		return API.get(`${ENDPOINTS.GET_BREEDERS}?${queryString.stringify(queryParams)}`)
	}

	async getBreedsBySize(breedSizeId) {
		// if breed size id is 6(All) remove query params
		const endpoint = breedSizeId === 6 ? ENDPOINTS.GET_BREEDS : `${ENDPOINTS.GET_BREEDS}?breedSize=${breedSizeId}`

		return API.get(endpoint)
	}
}

export default new BreedAPI()
